<h1>Usunięcie danych</h1>
<p>Aby usunąć wszystkie swoje dane wykonaj kolejno:</p>
<ol>
  <li>Usuń wszystkie swoje urządzenia (Ustawienia Organizacji -> Urządzenia -> Usuń urządzenie)</li>
  <li>Usuń wszystkich użytkowników swoich organizacji (Ustawienia Organizacji -> Członkowie organizacji ->
      Usuń użytkownika z organizacji)</li>
  <li>Usuń organizację (Ustawienia Organizacji -> Organizacja -> Usuń organizację)</li>
  <li>Usuń konto (Ustawienia Użytkownika -> Usuń konto)</li>
</ol>
